import { useTracking, type Track } from "@similarweb/tracking-provider";

export const useTrack = (): [Track] => {
    const { track } = useTracking();
    return [track];
};
